import { flatten } from 'flat'
import { useSearchParams } from '@/hooks/useSearchParams'
import { CollectionsValues } from '../types'
import { useCallback, useMemo } from 'react'
import { UseSearchParamSyncOptions } from './types'

export const useSearchParamsSync = ({
  defaultValues: providedDefaultValues,
}: UseSearchParamSyncOptions) => {
  const { searchParams, push } = useSearchParams()

  const getValues = useCallback(
    () =>
      Object.fromEntries(
        Object.entries(providedDefaultValues).map(([key, value]) => {
          const searchParam = searchParams.get(key)

          if (!searchParam) {
            return [key, value]
          }

          if (Array.isArray(value)) {
            return [key, searchParam.split(',')]
          }

          return [key, searchParam]
        }),
      ) as CollectionsValues,
    [searchParams],
  )

  const defaultValues = useMemo(getValues, [])

  const updateSearchParams = (values: CollectionsValues) => {
    push(
      Object.fromEntries([
        ...Object.entries(
          flatten<CollectionsValues, object>(values, { safe: true }),
        ).map(([key, value]) => {
          const isSet = Array.isArray(value) ? value.length > 0 : Boolean(value)
          return [key, isSet ? value : undefined]
        }),
        ['page', undefined],
      ]),
    )
  }

  return { defaultValues, getValues, updateSearchParams }
}
